import { companySchema } from "@/schema/Company";
import { z } from "zod";

export const companyCreateSchema = companySchema.omit({
  id: true,
}).extend({
  industry_code: z.string(),
  user_name: z.string().min(1),
  user_name_kana: z.string().nullish(),
  user_department: z.string().nullish(),
  user_position: z.string().nullish(),
  user_phone_number: z.string().nullish(),
  user_email: z.string().email(),
  user_password: z.string().min(8),
});

export type CompanyCreate = z.infer<typeof companyCreateSchema>;
